import { useAllPractitioners } from 'api/Practitioners'
import { keyBy } from 'lodash'
import { createSelector } from 'reselect'
import { pick } from 'utilities/ArrayUtils'

export const selectPractitioners = () => {
  const { data: { data: practitioners = [] } = {} } = useAllPractitioners()

  return practitioners
}

export const selectPractitionersById = () => {
  return createSelector([selectPractitioners], (practitioners) => keyBy(practitioners, 'id'))
}

export const selectPractitionersByIds = (practitionerIds = []) =>
  createSelector([() => practitionerIds, selectPractitioners], (practitionerIds, { byId }) =>
    Object.values(pick(byId, practitionerIds))
  )

export const selectPractitioner = (practitionerId) =>
  createSelector([selectPractitionersById], (byId) =>
    practitionerId === 'unassigned'
      ? { id: 'unassigned', name: 'Unassigned' }
      : byId[practitionerId] || null
  )
